import { render } from "./or-page-select.vue?vue&type=template&id=562ef2e8&bindings={\"menu_buttons\":\"data\",\"redirect\":\"options\"}"
import script from "./or-page-select.vue?vue&type=script&lang=js"
export * from "./or-page-select.vue?vue&type=script&lang=js"

import "./or-page-select.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script